export default __webpack_public_path__ + "static/media/FaqtopBg.3de8e095.jpeg";